import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Gmaps, Marker } from 'react-gmaps';
import { getWindowScrollTop } from '../helpers/index';

import * as mapActions from './MapActions';
import './Style';

class MapContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            apiKey: process.env.NODE_ENV === 'production' ? 'AIzaSyD6pjVhLYrAKJaDSz1xkImFVHa4UH4P4y8' : 'AIzaSyA5IbUQtja0ip7mRlm6isjp7IwYZocgfFE',
            error: null,
            errorInfo: null,
            mapLoad: false
        }

        this.windowOnScroll = this.windowOnScroll.bind(this);
    }

    componentDidMount() {
        if (this.mapPosition) {
            window.addEventListener('scroll', this.windowOnScroll, false);
        }
        window.addEventListener('message', (e) => {
            console.log('post-m-story-map',e.data);
            const {presentation} = e.data
            if (presentation) {
              this.setState({
                  presentation: true
              })
            }
          })
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error,
            errorInfo
        }, () => {
            console.error(error, errorInfo);
        });
    }

    componentWillUnmount() {
        if (this.mapPosition) {
            window.removeEventListener('scroll', this.windowOnScroll, false);
        }
    }

    windowOnScroll() {
        const windowScrollTop = getWindowScrollTop();
        const mapTop = this.mapPosition.offsetTop;
        const viewportHeight = document.documentElement.clientHeight;
        if (windowScrollTop > mapTop - viewportHeight) {
            this.setState({
                mapLoad: true
            })
        }

    }

    runGeocoder = () => {
        //if map should be shown but lat or lon wasn't set run the geocoder
        if (!this.props.geocoderDataFullfilled) {
            if (this.props.showMap && (!this.props.location.lat || !this.props.location.lon)) {
                this.props.mapActions.geocoder();
            }
        }
    }

    render() {
        const { showMap, location, mapInfo, geocoderError } = this.props;
        const { error } = this.state;

        if (geocoderError) {
            return (
            <div
                id="location"
                className="map-container"
                ref={el => this.mapPosition = el}
            >
                <h2 className="section-header">location</h2>
                <div className="mapNotFound">This address wasn't found</div>
            </div>
            )
        }

        if (!showMap || error) {
            return null;
        }

        return (
            <div
                id="location"
                className="map-container"
                ref={el => this.mapPosition = el}
                style={this.state.presentation ? {height: document.body.offsetWidth * (3/4)} :{}}
            >
                <h2 className="section-header">location</h2>
                {
                    this.state.mapLoad &&
                        <Gmaps
                            className="map-component"
                            width={'auto'}
                            height={'100%'}
                            lat={location.lat}
                            lng={location.lon}
                            zoom={mapInfo.zoom}
                            mapTypeControl={true}
                            mapTypeId={mapInfo.type}
                            params={{ key: this.state.apiKey }}
                            onMapCreated={this.runGeocoder}
                            gestureHandling={'cooperative'}>
                            <Marker
                                lat={location.lat}
                                lng={location.lon}
                            />
                        </Gmaps>
                }
            </div>
        );
    }
}

MapContainer.propTypes = {
    location: PropTypes.shape({
        lat: PropTypes.number.isRequired,
        lon: PropTypes.number.isRequired
    }),
    mapInfo: PropTypes.shape({
        zoom: PropTypes.number.isRequired,
        type: PropTypes.string,
        defaultStreetView: PropTypes.bool.isRequired
    }),
    showMap: PropTypes.bool.isRequired,
    getTourFulfilled: PropTypes.bool.isRequired,
    geocoderDataFullfilled: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => {
    return {
       getTourFulfilled: state.app.getTourFulfilled,
       location: state.map.location,
       mapInfo: state.map.info,
       showMap: state.map.showMap,
       geocoderDataFullfilled: state.map.geocoderDataFullfilled,
       geocoderError: state.map.geocoderError
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        mapActions: bindActionCreators(mapActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MapContainer)
